


import { CdkColumnDef } from '@angular/cdk/table';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
  ViewEncapsulation,
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { VesselStatusPopupComponent } from 'src/app/shared/components/vessel-status-popup/vessel-status-popup.component';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import {
  extractSegmentOptionsFromRecords,
  matchesAnySegment,
  matchesPortCallDateRange,
} from 'src/app/shared/helpers/pc-filter-options.util';
import {
  formatPcPortLocalAsUtc,
  formatPcUtcDateTime,
} from 'src/app/shared/helpers/pc-utc-datetime.util';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';
@Component({
  selector: 'app-insidecharter-view',
  templateUrl: './insidecharter-view.component.html',
  styleUrls: ['./insidecharter-view.component.scss']
})
export class InsidecharterViewComponent


  implements OnInit, AfterViewInit {
  @ViewChildren(CdkColumnDef) columnDefs!: QueryList<CdkColumnDef>;
  filterForm!: FormGroup;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('table', { static: false }) table!: ElementRef;
  paginatedData: any[] = [];
  itemsPerPage: number = 15;
  currentPage: number = 1;
  elements: any;
  counter = 1;
  segmentOptions: string[] = [];
  selectedSegments: string[] = [];
  filteredData: any;
  selectedTab: boolean | undefined;
  pastVoyagesComponent: any;
  data: any;
  shipNameSuggestions: any[] = [];
  edit: boolean = false;
  length: any;
  username: any;
  isFilterOpen = false;
  vesselHeaderName = '';
  vesselHeaderImo = '';
  vesselHeaderSegment = '';
  private initialVesselName = '';
  private initialVesselImo = '';
  private originalVesselName = '';
private originalVesselImo = '';
  subusername: any;
  constructor(
    private router: Router,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private sharedDataService: DashboardService,
    private requestFormService: RequestFormService,
    private prequestFormService: PortRequestFormServiceService,
    private dialog: MatDialog
  ) {
    this.filterForm = this.fb.group({
      from_date: [''],
      to_date: [''],
      shipName: [''],
      imoNumber: [''],
    });
  }
ngOnInit() {
  this.username = localStorage.getItem('username') ?? '';
  this.subusername = localStorage.getItem('loginPic') ?? '';

  const storedRow = this.sharedDataService.getRowData?.();
  // Get ORIGINAL values stored from previous page
  if (storedRow) {
    this.originalVesselName =
      storedRow.original_vessel_name ||
      storedRow.shipName ||
      '';

    this.originalVesselImo = String(
      storedRow.original_vessel_imo ||
      storedRow.imoNumber ||
      ''
    );
  }

  this.route.queryParams.subscribe((params) => {

    // These are DISPLAY values only
    const displayVesselName = params['vesselName'];
    const displayVesselImo = params['imo'];
    const segment = params['segment'] || '';

    if (!displayVesselName || !displayVesselImo) {
      return;
    }

    // Display values
    this.initialVesselName = displayVesselName;
    this.initialVesselImo = displayVesselImo;

    this.updateVesselHeader(
      displayVesselName,
      displayVesselImo,
      segment
    );

    // IMPORTANT:
    // For demo, DO NOT put masked values into API filter controls.
    this.filterForm.patchValue({
      shipName: this.originalVesselName,
      imoNumber: this.originalVesselImo,
    });

    this.loadData();
  });
}

  updateVesselHeader(
    vesselName?: string,
    vesselImo?: string,
    segment?: string,
    row?: any
  ): void {
const originalName =
    row?.shipName ||
    vesselName ||
    this.filterForm?.get('shipName')?.value ||
    '';

  const originalImo = String(
    row?.imoNumber ||
    vesselImo ||
    this.filterForm?.get('imoNumber')?.value ||
    ''
  );
    const segmentValue =
      row?.segment || segment || this.vesselHeaderSegment || '';

    this.vesselHeaderName = originalName;
    this.vesselHeaderImo = originalImo;


    this.vesselHeaderSegment =
      segmentValue && segmentValue !== '__' ? segmentValue : '';
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  @HostBinding('class.pc-light') get pcLight(): boolean {
    return !this.isDarkMode();
  }

  isMerakiOperations(): boolean {
  return this.username === 'Meraki - Operations';
}
  refresh() {
    if (this.username !== 'Eiger Shipping') {
      this.loadData();
    }
  }
  loadData() {
      const isDemo =
    this.subusername?.toLowerCase() === 'demo';

  // For API always use the ORIGINAL values
  const vesselName =  this.originalVesselName

  const vesselImo = this.originalVesselImo;

  if (!vesselName || !vesselImo) {
    return;
  }
    this.prequestFormService
      .getCharterPerformanceView(vesselName, vesselImo)
      .subscribe((res: any) => {
        this.data = Array.isArray(res) ? res : res?.data || [];

        this.elements = this.data.map((item: any, index: number) => ({
          sNo: index + 1,

          // BASIC
          shipName: item.vessel_name || '__',
          imoNumber: item.vessel_imo || '__',
          client: item.client || '__',
          segment: item.segment || '__',
          port: item.port || '__',
          operation: item.operations || '__',
          voyage: item.voyage_number || '__',
          cargo_quentity: item.cargo_quentity || '__',

          // DATE
          arrival: item.arrival_date_and_time || null,
          departure: item.departure_date_and_time || null,
          totalTime: item.total_time || '__',

          // ROB
          robArrival: item.brob_arrival_mt || {},
          robDeparture: item.brob_departure_mt || {},

          // ACTUAL
          actualConsumption: {
            HSFO: item.actual_consumption_mt?.hsfo ?? 0,
            VLSFO: item.actual_consumption_mt?.vlsfo ?? 0,
            MGO: item.actual_consumption_mt?.lsgo ?? 0
          },

          // CP
          cpConsumption: {
            HSFO: item.cp_warranted_consumptions_mt?.hsfo ?? 0,
            VLSFO: item.cp_warranted_consumptions_mt?.vlsfo ?? 0,
            MGO: item.cp_warranted_consumptions_mt?.lsgo ?? 0
          },

          // LOSS GAIN
          lossGain: {
            HSFO: item.cp_warrantedloss_or_gain_mt?.hsfo ?? 0,
            VLSFO: item.cp_warrantedloss_or_gain_mt?.vlsfo ?? 0,
            MGO: item.cp_warrantedloss_or_gain_mt?.lsgo ?? 0
          },

          // OPS
          actualOps: item.actual_consumption_ops || {},
          cpOps: item.cp_warranted_consumption_Ops || {}
        }));

        if (this.elements.length > 0) {
          // this.updateVesselHeader(undefined, undefined, undefined, this.elements[0]);
        }

        this.segmentOptions = extractSegmentOptionsFromRecords(this.elements);
        this.filteredData = [...this.elements];
        this.resetPagination();

      });
  }
  filterShipNames(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (inputValue.length > 0) {
      this.shipNameSuggestions = (this.elements || []).filter((item: any) =>
        String(item.shipName || '')
          .toLowerCase()
          .includes(inputValue),
      );
    } else {
      this.shipNameSuggestions = [];
    }
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe((sort: Sort) => {
      this.sortData(sort);
    });
  }
  paginateData() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;

    this.paginatedData = this.filteredData.slice(
      startIndex,
      startIndex + this.itemsPerPage
    );

    this.length = this.filteredData.length;
  }

  private resetPagination(): void {
    this.currentPage = 1;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.paginateData();
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.itemsPerPage = event.pageSize || this.itemsPerPage;
    this.paginateData();
  }

  /** Normalize numeric values and treat floating-point noise as zero. */
  formatUTCDate(dateValue: any): string {
    return formatPcUtcDateTime(dateValue);
  }

  formatPortDate(dateValue: any, portName?: string | string[] | null): string {
    const port = Array.isArray(portName) ? portName[0] : portName;
    return formatPcPortLocalAsUtc(dateValue, port);
  }

  normalizeMtValue(value: unknown): number {
    const n = Number(value);
    if (!Number.isFinite(n)) {
      return 0;
    }
    const rounded = Math.round(n * 1000) / 1000;
    return Math.abs(rounded) < 1e-6 ? 0 : rounded;
  }

  /** Plain decimal display (e.g. 23.33, 345.667), never scientific notation. */
  formatDecimal(value: unknown): string {
    const n = this.normalizeMtValue(value);
    if (n === 0) {
      return '0';
    }
    return n.toFixed(3).replace(/\.?0+$/, '');
  }

  /** MT cell — optional dash when zero (HSFO columns). */
  formatMt(value: unknown, dashWhenZero = false): string {
    const n = this.normalizeMtValue(value);
    if (dashWhenZero && n === 0) {
      return '-';
    }
    return this.formatDecimal(n);
  }

  getTotalActualConsumption(element: any): number {
    return (
      this.normalizeMtValue(element.actualConsumption?.HSFO) +
      this.normalizeMtValue(element.actualConsumption?.VLSFO) +
      this.normalizeMtValue(element.actualConsumption?.MGO)
    );
  }

  getTotalCpConsumption(element: any): number {
    return (
      this.normalizeMtValue(element.cpConsumption?.HSFO) +
      this.normalizeMtValue(element.cpConsumption?.VLSFO) +
      this.normalizeMtValue(element.cpConsumption?.MGO)
    );
  }

  getTotalLossGain(element: any): number {
    return (
      this.normalizeMtValue(element.lossGain?.HSFO) +
      this.normalizeMtValue(element.lossGain?.VLSFO) +
      this.normalizeMtValue(element.lossGain?.MGO)
    );
  }

  formatLossGainMt(value: number): string {
    return this.formatDecimal(value);
  }

  formatCargoQty(value: unknown): string {
    if (value === null || value === undefined || value === '' || value === '__') {
      return '__';
    }
    const n = Number(value);
    return Number.isFinite(n) ? this.formatDecimal(n) : String(value);
  }

  getLossGainColor(element: any): string {
    const total = this.getTotalLossGain(element);
    if (total < 0) {
      return '#ff4d4f';
    }
    if (total > 0) {
      return '#52c41a';
    }
    return 'inherit';
  }

  getPerformanceDiff(reference: unknown, actual: unknown): number {
    return this.normalizeMtValue(reference) - this.normalizeMtValue(actual);
  }

  getOpsLossGain(cpValue: unknown, actualValue: unknown): number {
    return this.getPerformanceDiff(cpValue, actualValue);
  }

  getPerformanceDiffColor(value: number): string {
    if (value < 0) {
      return '#ff4d4f';
    }
    if (value > 0) {
      return '#52c41a';
    }
    return 'inherit';
  }
  sortData(sort: Sort) {
    const data = this.elements.slice();
    if (!sort.active || sort.direction === '') {
      this.elements = data;
      return;
    }

    this.elements = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      return this.compare(a, b, isAsc, sort.active);
    });
  }
  goBack() {
    this.router.navigate(['/pc-charter-performance']);
  }
  compare(a: any, b: any, isAsc: boolean, column: string) {
    let valueA = this.getNestedValue(a, column);
    let valueB = this.getNestedValue(b, column);

    if (valueA === null || valueA === undefined) return isAsc ? -1 : 1;
    if (valueB === null || valueB === undefined) return isAsc ? 1 : -1;

    const numericalColumns = ['timeLost', 'hsfo', 'vlsfo', 'go'];
    if (numericalColumns.includes(column)) {
      valueA = parseFloat(valueA);
      valueB = parseFloat(valueB);
      return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
    }

    return (valueA < valueB ? -1 : 1) * (isAsc ? 1 : -1);
  }

  getNestedValue(obj: any, column: string) {
    switch (column) {
      case 'hsfo':
      case 'vlsfo':
      case 'go':
        return obj.bunkerLostOrGain[column.toUpperCase()];
      default:
        return obj[column];
    }
  }
  showDetails(row: any) {
    this.sharedDataService.setRowData(row);
    this.router.navigate(['/vp-shipView']);
  }
  downloadIcon(ow: any) {
    this.toastr.success(ToasterMessages.UnderDev);
  }

  editedRowIndex: number | null = null;
  editedColumnName: string | null = null;
  editCell(rowIndex: number, columnName: string) {
    this.editedRowIndex = rowIndex;
    this.editedColumnName = columnName;
  }
  exitEdit() {
    this.editedRowIndex = null;
    this.editedColumnName = null;
  }
  calculateClaimableAmount(element: any) {
    const claimEst = element.claimEst;
    const fuelLost = element.bunkerLostOrGain;

    if (
      claimEst === null ||
      claimEst === undefined ||
      claimEst.hire === '' ||
      claimEst.bunkPrice === ''
    ) {
      return '__';
    }
    const HSFO = fuelLost && fuelLost.HSFO === '__' ? 0 : fuelLost.HSFO;
    const VLSFO = fuelLost && fuelLost.VLSFO === '__' ? 0 : fuelLost.VLSFO;
    const GO = fuelLost && fuelLost.GO === '__' ? 0 : fuelLost.GO;
    const bunkPrice =
      claimEst && claimEst.bunkPrice !== null ? claimEst.bunkPrice : 0;
    const hireClaim = claimEst ? claimEst.hire * (element.timeLost / 24) : 0;
    const fuelClaim = fuelLost
      ? bunkPrice * (HSFO || 0) +
      bunkPrice * (VLSFO || 0) +
      bunkPrice * (GO || 0)
      : 0;

    const totalClaim = hireClaim + fuelClaim;

    return isNaN(totalClaim) || totalClaim === undefined
      ? '__'
      : Math.round(totalClaim);
  }
  getRowSerialNumber(index: number): number {
    return (this.currentPage - 1) * this.itemsPerPage + index + 1;
  }

  closeFilterDrawer(): void {
    this.isFilterOpen = false;
  }

  clearClick() {
    this.filterForm.patchValue({
      from_date: '',
      to_date: '',
      shipName: this.initialVesselName,
      imoNumber: this.initialVesselImo,
    });
    this.selectedSegments = [];

    this.filteredData = [...this.elements];
    this.resetPagination();
    this.isFilterOpen = false;
  }

  filterClick() {
    const formValues = this.filterForm.value;
    const shipName = formValues.shipName?.toLowerCase()?.trim();
    const imo = String(formValues.imoNumber ?? '').trim();

    this.filteredData = (this.elements || []).filter((item: any) => {
      const matchesDate = matchesPortCallDateRange(
        item.arrival,
        item.departure,
        formValues.from_date,
        formValues.to_date,
      );

      return (
        matchesDate &&
        (!shipName ||
          String(item.shipName || '')
            .toLowerCase()
            .includes(shipName)) &&
        (!imo || String(item.imoNumber ?? '').includes(imo)) &&
        matchesAnySegment(item.segment, this.selectedSegments)
      );
    });

    this.resetPagination();
    this.isFilterOpen = false;

    if (this.filteredData.length === 0) {
      this.toastr.info('No matching records found');
    }
  }
  exportClick() {
    const data = this.elements;
    const csvHeader =
      'Ship Name,Segment,Time Lost (or) Gain,HSFO,VLSFO,GO,Daily Hire,Avg Bunker Price,Claimable Amount';
    const csvData = data
      .map((item: any) => {
        const bunkLostGain = item.bunkerLostOrGain
          ? `${item.bunkerLostOrGain.HSFO},${item.bunkerLostOrGain.VLSFO},${item.bunkerLostOrGain.GO}`
          : ',,';
        const claimEst = item.claimEst
          ? `${item.claimEst.hire},${item.claimEst.bunkPrice}`
          : ',';
        return `${item.shipName},${item.segment},${item.timeLost
          },${bunkLostGain},${claimEst},${this.calculateClaimableAmount(item)}`;
      })
      .join('\n');
    const csvContent = `${csvHeader}\n${csvData}`;
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'table_data.csv';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }
  printTable() {
    // Use all elements or filteredData based on what you want to print
    const dataToPrint = this.filteredData || this.elements;

    // Generate the HTML content for the table
    const tableHtml = `
      <html>
        <head>
          <style>
          
  .tableTitle {
    display: block;
    position:fixed; 
    top: 0px !important;
    left: 10px !important;
    width: 100%;
    font-size: 1.2em;
    margin-bottom: 10px; 
     color: #766b6b;
     font-family: "Poppins", sans-serif;
     page-break-before: avoid;
  }
  .printable-table {
    position: absolute;
    max-height: 100%;
    top: 50px;
    page-break-inside:avoid;
  }
  .filter{
    display: none;
  }
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
     @page {
              size: A4;
              margin: 0; /* Remove margins */
            }

  table {
    width: 100%;
    min-width: 100%;
    border: 0;
    white-space: nowrap;
    border-spacing: 0;
    box-shadow: 0px 0px 20px 0px rgba(82, 63, 105, 0.15);
  }
  th.time {
    white-space: nowrap;
  }
  .scroll-bar {
    overflow-x: scroll !important;
    overflow-y: hidden;
  }
  th,
  td {
    min-width: 85px;
    font-weight: 500;
    font-family: "Poppins", sans-serif;
    text-align: center !important;
    vertical-align: middle;
    padding-top: 0px;
    padding-bottom: 0px;
    font-size: 13px;
  }
  th {
    background-color: #0a4380d9;
    color: white;
    border: 1px solid #8d8e8f;
    padding-left: 5px;
    padding-right: 5px;
  }
  td {
    color: #766b6b;
    white-space: nowrap;
    padding:10px
  }
  tr {
    &:nth-child(even) {
      background-color: #cbeaf0;
    }
    &:nth-child(odd) {
      background-color: #f5fdff;
    }
  }
     .logo {
            position: absolute;
            top: 0px;
            right: 10px;
            width: 65px;
          }
          </style>
        </head>
        <body>
         <img src="../../../assets/images/logo.png" class="logo" />
          <h2 class="tableTitle">Fleet View Table</h2>
          <table class="printable-table">
            <thead>
              <tr>
               <th   rowspan="2">S.No</th>
              <th   rowspan="2">Ship Name</th>
              <th   rowspan="2">IMO Number</th>
              <th   rowspan="2">Segment</th>
              <th   rowspan="2">Time Lost</th>
              <th colspan="3"> Bunker Lost(-) or Gained(mt)</th>
              </tr>
              <tr>
                <th class="th-text-center2" mat-sort-header="hsfo"><span>HSFO</span></th>
                <th class="th-text-center2" mat-sort-header="vlsfo"><span>VLSFO</span></th>
                <th class="th-text-center2" mat-sort-header="go"><span>GO</span></th>
              </tr>
            </thead>
            <tbody>
              ${dataToPrint
        .map(
          (item: any, index: number) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${item.shipName}</td>
                  <td>${item.imoNumber}</td>
                  <td>${item.segment}</td>
                  <td>${item.timeLost}</td>
                  <td>${item.bunkerLostOrGain.HSFO}</td>
                  <td>${item.bunkerLostOrGain.VLSFO}</td>
                  <td>${item.bunkerLostOrGain.GO}</td>
                </tr>
              `
        )
        .join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;

    // Create a new iframe element for printing
    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    const iframeDocument =
      iframe.contentDocument || iframe.contentWindow?.document;

    if (iframeDocument) {
      iframeDocument.open();
      iframeDocument.write(tableHtml);
      iframeDocument.close();

      // Trigger print
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();

      // Clean up
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    }
  }

  downloadClick() {
    this.toastr.success(ToasterMessages.UnderDev);
  }
  tabChanged(event: MatTabChangeEvent) {
    // this.selectedTab = !this.selectedTab;
    // if (this.pastVoyagesComponent) {
    //   this.pastVoyagesComponent.refresh();
    // }
  }
  editClick() {
    this.edit = true;
  }
  onCheckboxChange(event: Event, element: any) {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (isChecked) {
      const dialogRef = this.dialog.open(VesselStatusPopupComponent, {
        width: '400px',
        height: '228px',
        disableClose: true,
        data: {
          reasonOptions: element.vessel_status, // Pass reason options
        },
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          let payload = {
            imo: element.imoNumber,
            reason: result.reason,
            status: result.status,
          };
          this.sharedDataService
            .updateStatus(payload)
            .subscribe((data: any) => {
              this.edit = false;
              this.toastr.success(ToasterMessages.SuccessMessage);
              this.loadData();
            });
        }
      });
    }
  }

  private segmentColorMap: { [key: string]: string } = {
    mr: '#c27036',
    handymax: '#369047',
    suezmax: '#6a6a6a',
    vlcc: '#3249d4',
    aframax: '#7e3b3b',
    'gas tanker': '#5b5418',
    handy: '#35707b',
    lr1: '#2a644f',
    lr2: '#556ba6',
    coaster: '#859914ff',
    handysize: '#541e85',
    supramax: '#6b181f',
    ultramax: '#85501c',
    panamax: '#723768',
    kamsarmax: '#077c5f',
    'ultra panamax': '',
    capesize: '#7c7440',
    chinamax: '',
    'lr1/panamax': '#42bfaaff',
    'lr2/aframax': '#427ebf',
    'lr3/suezmax': '#bf4281ff',
    bitumen: '#7b4d75',
  };

  getDynamicSegmentStyle(segment: string): any {
    if (!segment) return {};

    const key = segment.toLowerCase();

    // If NOT in static mapping → assign dynamic color
    if (!this.segmentColorMap[key]) {
      this.segmentColorMap[key] = this.generateDarkColorFromText(key);
    }

    const color = this.segmentColorMap[key];

    return {
      'background-color': color,
      'border-radius': '12px',
      padding: '0px 6px',
      color: '#fff',
      display: 'inline-block',
      'font-weight': '500',
      'text-transform': 'uppercase',
      'font-size': '12px',
      'letter-spacing': '0.5px',
    };
  }

  /** Generates a consistent dark color for unknown segments */
  private generateDarkColorFromText(text: string): string {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    let r = (hash >> 16) & 0xff;
    let g = (hash >> 8) & 0xff;
    let b = hash & 0xff;

    // Force dark tones
    r = Math.floor(r * 0.4);
    g = Math.floor(g * 0.4);
    b = Math.floor(b * 0.4);

    return `rgb(${r}, ${g}, ${b})`;
  }
}
